import { render, staticRenderFns } from "./AttributeReport.vue?vue&type=template&id=d7a60d80&scoped=true"
import script from "./AttributeReport.vue?vue&type=script&lang=js"
export * from "./AttributeReport.vue?vue&type=script&lang=js"
import style0 from "./AttributeReport.vue?vue&type=style&index=0&id=d7a60d80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a60d80",
  null
  
)

export default component.exports